import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=330432ba"
import script from "./PlayBox.vue?vue&type=script&lang=js"
export * from "./PlayBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports